import Form from "@/types/Form.interface"

interface State {
    formCount: number
    forms: Form[]
}

const defaults = () => {
    return {
        formCount: 0,
        forms: []
    }
}

export default {
    state: defaults(),
    mutations: {
        formCountSet (state: State, count: number): void {
            state.formCount = count
        },
        formsPush (state: State, forms: Form[]): void {
            state.forms = window.removeDuplicatesById(state.forms, forms)
        },
        formsRemove (state: State, ids: number[]): void {
            //  Get our global list of forms
            const forms = state.forms

            //  If no forms, do nothing
            if (!forms) return

            //  Else, filter out our removed ids
            const filtered = forms.filter((x: Form) => !ids.includes(x.id))

            //  Replace our list with the filtered list
            state.forms = filtered
        },
        formsReset (state: State): void {
            Object.assign(state, defaults())
        },
        formsSet (state: State, forms: Form[]): void {
            state.forms = forms
        }
    },
    actions: {
        formsCount ({ commit, getters }): Promise<number> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms/count`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our forms count
                commit('formCountSet', response.data)

                //  Return the total forms count
                return response.data
            }).catch(() => null)
        },
        formsDelete ({ commit, getters }, formId: number): Promise<Form> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms/${formId}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  Update our forms
                commit('formsRemove', [response.data.id])

                //  Update our forms view
                commit('formsViewFormsRemove', [response.data.id])

                //  Return the deleted form
                return response.data
            }).catch(() => null)
        },
        formsFind ({ commit, getters }, formId: number): Promise<Form> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms/${formId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Update our global list
                commit('formsPush', [response.data])

                //  Return our found form
                return response.data
            }).catch(() => null)
        },
        formsGet ({ commit, getters }): Promise<Form[]> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms/all`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our global forms list
                commit('formsSet', response.data)

                //  Set our forms view forms
                commit('formsViewFormsSet', response.data)

                //  Return the forms
                return response.data
            }).catch(() => null)
        },
        formsPost ({ commit, getters }, form: Form): Promise<Form> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms`

            //  Send the request
            return window.axios.post(url, form).then(response => {
                //  Update our global list
                commit('formsPush', [response.data])

                //  Update our forms view forms
                commit('formsViewFormsPush', [response.data])

                //  REturn our created form
                return response.data
            }).catch(() => null)
        },
        formsPut ({ commit, getters }, form: Form): Promise<Form> {
            //  Assemble the API endpoint
            const url = `${getters.api}/forms`

            //  Send the request
            return window.axios.put(url, form).then(response => {
                //  Update our global list
                commit('formsPush', [response.data])

                //  Update our forms view forms
                commit('formsViewFormsPush', [response.data])
                
                //  Return the updated form
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        formCount (state: State): number {
            return state.formCount
        },
        forms (state: State): Form[] {
            return state.forms
        }
    }
}
